// extracted by mini-css-extract-plugin
module.exports = {"link":"AccountLink_link__8znQK","icon":"AccountLink_icon__K2dUz","text":"AccountLink_text__8Xty9"};